//styles
import { useEffect, useState } from 'react'
import Select from 'react-select'
import './create.css'

import { useAuthcontext } from '../../hooks/useAuthcontext'
import { useCollection } from '../../hooks/useCollection'
import { timestamp } from '../../firebase/config'
import {useFirestore} from '../../hooks/useFirestore'

import { useNavigate } from 'react-router-dom';

const categories = [
  {value: 'development', label:'Development'},
  {value: 'design', label:'design'},
  {value: 'sales', label:'sales'},
  {value: 'marketing', label:'marketing'}
]
const Create = () => {
  let navigate = useNavigate();
  const { addDocument, response } = useFirestore('projects')
  const{document} = useCollection('users')
  const[users,setUsers] = useState([])
  const{user} = useAuthcontext()

  //form field values
  const[name,setName] = useState('')
  const[details,setDetails] = useState('')
  const[dueDate,setDueDate] = useState('')
  const[category,setCategory] = useState('')
  const[assignedUsers,setAssignedUsers] = useState([])
  const[formError, setFormError]= useState('')

  useEffect(() => {
    if (document) {
      const options = document.map(user => {
        return {value: user, label: user.displayName}
      })
      setUsers(options)
    }
  },[document])
  const handleSubmit = async(e) => {
    e.preventDefault()
    setFormError(null)
    if (!category) {
      setFormError('Please select a project category')
      return
    }
    if (assignedUsers.length < 1) {
      setFormError('please assign the project to atleast 1 user')
      return
    }

    const createdBy = {
      displayName: user.displayName,
      id: user.uid
    }
    const assignedUsersList = assignedUsers.map((u) => {
      return {
        display: u.value.displayName,
        id: u.value.id
      }
    })
    
    const project = {
      name,
      details,
      category: category.value,
      dueDate: timestamp,
      createdBy,
      assignedUsersList
    }
      await addDocument(project)
      if (!response.error) {
        navigate('/')
      }
  }
  return (
    <div className='create-form'> 
      <h2 className='page-title'>Create a new project</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <span>Project Name:</span>
          <input 
            required
            type='text'
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </label>
        <label>
          <span>Project details:</span>
          <textarea
            required
            type="text"
            onChange={(e) => setDetails(e.target.value)}
            value={details}
          />
        </label>
        <label>
          <span>Set Due date:</span>
          <input 
            required
            type='date'
            onChange={(e) => setDueDate(e.target.value)}
            value={dueDate}
          />
        </label>
        <label>
          <span>Project category:</span>
          <Select 
            options={categories}
            onChange={(option) => setCategory(option)}
            />
        </label>
        <label>
          <span>Assign to:</span>
            <Select 
              options={users}
              onChange={(option) => setAssignedUsers(option)}
              isMulti
              />
        </label>
        {
        response.isPending ? <button className='btn' disabled>Adding Project...</button> : <button className='btn'>Add Project</button>
        }
        
        {formError && <p className='error'>{formError}</p>}
      </form>
    </div>
  )
}

export default Create